<template>
    <div class="table-footer">
        <div class="left">
            <div class="record-count">{{ $t("tables.recordCount") }}: {{ recordCount }}</div>

            <SupsisButton class="increase-limit-btn" :disabled="true" @click="increaseLimit" v-if="false">
                <i class="material-icons">add</i> {{ $t("tables.increaseLimit") }}
            </SupsisButton>

            <SupsisButton
                class="new-record-btn"
                @click="$feature.beforeCreateTableRecord(createNewRecord, recordCount)"
            >
                <i class="material-icons">add_box</i> {{ $t("tables.newRecord") }}
            </SupsisButton>
            <SupsisButton class="import-btn" @click="$feature.beforeCreateTableRecord(importRecords, recordCount)">
                <i class="material-icons">cloud_upload</i> {{ $t("tables.imports") }}
            </SupsisButton>
            <SupsisButton class="export-btn" @click="exportRecords">
                <i class="material-icons">cloud_download</i> {{ $t("tables.exports") }}
            </SupsisButton>
            <SupsisButton class="download-btn" :disabled="true" @click="downloadRecords" v-if="false">
                <i class="material-icons">get_app</i> {{ $t("tables.download") }}
            </SupsisButton>
        </div>
        <div class="right">
            <a-pagination
                v-if="recordCount > cursor.perPage"
                :current="cursor.page"
                :total="recordCount"
                :pageSize="cursor.perPage"
                show-size-changer
                show-quick-jumper
                :pageSizeOptions="['100', '250', '500', '750', '1000']"
                @change="onPageChange"
                @showSizeChange="onShowSizeChange"
                size="small"
            />
            <a-popover trigger="click" placement="topRight">
                <template slot="content">
                    <div class="automation-popover custom-automation-popover">
                        <div class="group">
                            <div class="group-title">{{ $t("ticimax.createAutomation") }}</div>
                            <div class="group-item event" @click="showCreateAutomationModal('table.record_created')">
                                <i class="material-icons">add</i> {{ $t("tables.recordCreated") }}
                            </div>
                            <div class="group-item event" @click="showCreateAutomationModal('table.record_updated')">
                                <i class="material-icons">update</i> {{ $t("tables.recordUpdated") }}
                            </div>
                            <div class="group-item event" @click="showCreateAutomationModal('table.record_deleted')">
                                <i class="material-icons">delete</i> {{ $t("tables.recordDeleted") }}
                            </div>
                        </div>
                        <div class="group">
                            <div class="group-title">{{ $t("automation.automations") }}</div>
                            <div
                                v-for="automation in tableAutomations"
                                :key="automation._id"
                                class="group-item automation"
                                @click="goToAutomation(automation._id)"
                            >
                                <component is="atomic-power" class="myIcon" />
                                {{ automation.name }}
                            </div>
                            <div v-if="!tableAutomations.length" class="no-automation">
                                <i class="material-icons">info</i> {{ $t("tables.noAutomationDefined") }}
                            </div>
                        </div>
                    </div>
                </template>
                <SupsisButton class="automate-btn" type="primary">
                    <i class="material-icons">settings_applications</i> {{ $t("tables.automateYourData") }}
                </SupsisButton>
            </a-popover>
        </div>

        <a-modal v-model="createAutomationModalVisible" :title="$t('ticimax.createAutomation')" @ok="createAutomation">
            <div class="automation-name-input">
                <div class="description">
                    <template v-if="selectedAutomationEvent === 'table.record_created'">
                        {{ $t("tables.nameTheAutomationAdd") }}
                    </template>
                    <template v-else-if="selectedAutomationEvent === 'table.record_updated'">
                        {{ $t("tables.nameTheAutomationUpdate") }}
                    </template>
                    <template v-else-if="selectedAutomationEvent === 'table.record_deleted'">
                        {{ $t("tables.nameTheAutomationDelete") }}
                    </template>
                </div>
                <a-input v-model="automationName" :placeholder="$t('automation.automationName')" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import Vue from "vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { AUTOMATION_API } from "../../../../api/automation";

export default Vue.extend({
    name: "TableFooter",
    components: {
        SupsisButton,
    },
    props: {
        recordCount: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        tableId: {
            type: String,
            required: true,
        },
        cursor: {
            type: Object,
            required: true,
            default: () => ({
                page: 1,
                perPage: 100,
            }),
        },
    },
    data() {
        return {
            createAutomationModalVisible: false,
            automationName: "",
            selectedAutomationEvent: "",
            tableAutomations: [],
        };
    },

    methods: {
        increaseLimit() {
            // Limit artırma işlemi
        },
        async createNewRecord() {
            this.$emit("create-new-record");
        },
        importRecords() {
            this.$emit("open-import-modal");
        },
        exportRecords() {
            this.$emit("export-records");
        },
        downloadRecords() {
            // Kayıtları indirme işlemi
        },
        automateData() {
            // Veri otomasyonu işlemi
        },
        showCreateAutomationModal(event) {
            this.selectedAutomationEvent = event;
            this.createAutomationModalVisible = true;
        },
        async createAutomation() {
            try {
                const automation = await AUTOMATION_API.createEmptyEventAutomation(
                    this.automationName,
                    this.selectedAutomationEvent,
                    {
                        filter: {
                            all: true,
                        },
                    },
                    {
                        table: this.tableId,
                    }
                );
                this.$message.success(this.$t("automation.eventAutomationCreatedSuccessfully"));
                this.createAutomationModalVisible = false;
                this.automationName = "";
                await this.fetchTableAutomations();
                this.goToAutomation(automation._id);
            } catch (error) {
                console.error("Error while creating automation", error);
                this.$message.error(this.$t("automation.automationCouldNotBeCreated"));
            }
        },
        goToAutomation(automationId) {
            this.$router.push(`/automations/${automationId}/design`);
        },
        async fetchTableAutomations() {
            try {
                const automations = await AUTOMATION_API.listAutomations({
                    filters: [],
                    cursor: {
                        offset: 0,
                        limit: 1000,
                    },
                });
                this.tableAutomations = automations.items.filter(
                    (automation) => automation.reference?.table === this.tableId
                );
            } catch (error) {
                console.error("Error while fetching automations", error);
            }
        },
        onPageChange(page, pageSize) {
            this.$emit("change-cursor", {
                page: page,
                perPage: pageSize,
            });
        },
        onShowSizeChange(current, size) {
            this.$emit("change-cursor", {
                page: 1, // Sayfa boyutu değiştiğinde ilk sayfaya dön
                perPage: size,
            });
        },
    },
    created() {
        this.fetchTableAutomations();
    },
});
</script>

<style lang="scss">
.custom-automation-popover {
    .group-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px;
        transition: background-color 0.3s;

        &:hover {
            background-color: #f0f0f0;
        }
        &.automation {
            svg {
                fill: var(--color-icon-primary-default);
            }
        }
        &.event {
            i {
                font-size: 20px;
            }

            &:nth-child(2) i {
                color: #b2d8b2;
            }

            &:nth-child(3) i {
                color: #bad7f2;
            }

            &:nth-child(4) i {
                color: #f2c4c4;
            }
        }
    }

    .group-item i {
        font-size: 18px;
    }

    .no-automation {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px;
        color: #999;
        font-style: italic;
    }
}
</style>

<style scoped lang="scss">
.table-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 5px;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    height: 40px;

    .left {
        display: flex;
        align-items: center;
        gap: 10px;

        :deep(.ant-pagination) {
            margin-left: 16px;

            .ant-select-selection-selected-value {
                font-size: 12px;
            }

            .ant-pagination-options-quick-jumper {
                font-size: 12px;

                input {
                    font-size: 12px;
                }
            }
        }
    }

    .right {
        display: flex;
        align-items: center;
    }
}

.automation-name-input {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .description {
        font-size: 14px;
    }
}
</style>
